import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import { KitTrackingInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import { KitTrackingSchema } from "../../../Schemas/sales/kit_tracking_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const AddKitTracking = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handelSubmit = (values) => {
    values = {
        ...values,
        generatedById: store.UserId,
        generatedBy: store.Name,
      };
    setLoading(true);
    performRequest("POST", `/kitTracking/creatKitTracking`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Kit Tracking created successfully!");
          navigate(`/kitTracking`);
        } else {
          Toast("error", "Error while updating Kit Tracking");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Kit Tracking</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Add Kit Traking</h2>
            </div>
            <Formik
              initialValues={KitTrackingInfo}
              validationSchema={KitTrackingSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Order Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="orderDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Client Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="clientName"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Contact Number
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="clientContactNumber"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Address
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="clientAddress"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Type Of Kit
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="typeOfKit" className="form-control">
                          <option value="">Select Type</option>
                          <option value="site inspection kit">
                            Site Inspection Kit
                          </option>
                          <option value="dutch bucket home kit">
                            Dutch Bucket Home Kit
                          </option>
                          <option value="verticle nft home kit ">
                            Verticle NFT Home Kit
                          </option>
                          <option value="flat bed system">
                            Flat Bed System
                          </option>
                        </CustomSelect>

                        {props.touched.typeOfKit && props.errors.typeOfKit && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.typeOfKit}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Courier Service
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="courierServiceProvider"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Courier Service Person Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="courierServiceProviderPersonName"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Courier Service Person Contact Number
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="courierServiceProviderPersonContactNumber"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Courier Tracking Id
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="courierTrackingId"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Kit Dispatch Address
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="kitDispatchAddress"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Kit Price
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="kitPrice"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Service Charge
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="courierServiceCharge"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Dispatch Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="dispatchDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Delivery Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="deliveryDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Note
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="note" rows={5} />
                        {props.touched.note && props.errors.note && (
                          <p className="text-danger">{props.errors.note}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Add Kit Tracking" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddKitTracking;
